import type { IButton } from "@Components/Button";
import ImageLoader, { type IImageLoader } from "@Components/ImageLoader";

import { TransitionButton } from "../common/Transition";

import * as css from "./LoyaltyProgramItem.module.css";

export interface ILoyaltyProgramItem {
    cardImage: IImageLoader;
    shoppingMallImage?: IImageLoader;
    shoppingMallDescription?: string;
    detailsButton: IButton;
    isMobile: boolean;
}

export const LoyaltyProgramItem = (props: ILoyaltyProgramItem) => (
    <div className={css.loyaltyProgramItemComponent}>
        <div className={css.cardImage}>{props.cardImage && <ImageLoader {...props.cardImage} />} </div>
        {!props.isMobile && (
            <div className={css.shoppingMallImage}>
                {" "}
                {props.shoppingMallImage && <ImageLoader {...props.shoppingMallImage} />}{" "}
            </div>
        )}
        <div className={css.rightColumn}>
            <div className={css.shoppingMallDescription}>{props.shoppingMallDescription}</div>
            <TransitionButton {...props.detailsButton} />
        </div>
    </div>
);
